import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import React from 'react'

interface ValueBandsToolTipProps {
    inverseColor: boolean
}
const ValueBandsToolTip = (props: ValueBandsToolTipProps) => {
    const { inverseColor } = props
    return (
        <CustomToolTip
            type="?"
            inverse={inverseColor}
            info={
                'This is the estimated value of the unmatched usages ' +
                'within this recording group. The values bands are: ' +
                ' $ = less than one dollar $$ = $1.00 to $10.00 $$$ = $10.01 to $50.00' +
                ' $$$$ = $50.01 to $250.00 $$$$$ = $250.01 and above'
            }
        />
    )
}

export default ValueBandsToolTip
